import { Link } from 'react-router-dom';
import { ShieldAlert, Home } from 'lucide-react';
import { ROUTES } from '@constants';
import Button from '@components/common/Button';

const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <ShieldAlert className="w-24 h-24 text-secondary-600 mx-auto mb-6" />
        <h1 className="text-6xl font-bold text-primary-700 mb-4">401</h1>
        <h2 className="text-3xl font-bold text-primary-700 mb-4">Unauthorized</h2>
        <p className="text-primary-600 mb-8 max-w-md">
          You don't have permission to access this resource.
        </p>
        <Link to={ROUTES.HOME}>
          <Button variant="primary" size="lg">
            <Home className="w-5 h-5 mr-2" />
            Go Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
